<template>
  <div class="form-row trigger">
    <b-col class="float-left">
      <!-- {{options}} -->
      <multiselect
        :allow-empty="allowEmpty"
        :disabled="disabled"
        :class="
          isValid === null
            ? ''
            : isValid
            ? 'multiselect__valid'
            : 'multiselect__invalid'
        "
        label="text"
        track-by="value"
        :loading="loading"
        :options="options"
        :placeholder="placeholder || this.$lang.multiselect.placeholder"
        :searchable="true"
        :selectLabel="$lang.multiselect.selectLabel"
        :selectedLabel="$lang.multiselect.selectedLabel"
        :show-labels="true"
        :taggable="taggable"
        @input="updateValue"
        @search-change="delaySearch"
        :tag-placeholder="$lang.multiselect.selectLabel"
        @tag="addTag"
        deselect-label
        v-bind="$attrs"
        v-model="output"
        :multiple="multiple"
      >
        <template slot="noOptions">
          <strong>{{ $lang.multiselect.noOptions }}</strong>
        </template>
      </multiselect>

      <!-- <div>
        <label class="typo__label">Tagging</label>
        <multiselect v-model="value" tag-placeholder="Add this as new tag" placeholder="Search or add a tag"
          label="text" track-by="value" :options="options" :multiple="true" :taggable="true" @tag="addTag"></multiselect>
        <pre class="language-json"><code>{{ value  }}</code></pre>
      </div> -->
      <div :style="style" class="addForm">
        <transition name="fade">
          <addEnum
            :categoryName="categoryName"
            @saved="enumSaved"
            v-if="!isAdd"
          ></addEnum>
        </transition>
      </div>
    </b-col>
    <div class="float-right" v-if="showButton">
      <b-button
        :variant="isAdd ? '' : 'danger'"
        @click="buttonClicked"
        class="m-1 plusButton btn-lightgray"
      >
        <i class="fa fa-plus" v-if="isAdd"></i>
        <i class="fa fa-close" v-else></i>
      </b-button>
    </div>
  </div>
</template>

<style lang="scss" scoped>
.fade-enter-active,
.fade-leave-active {
  transition: opacity 0.66s;
}

.fade-enter,
  .fade-leave-to

  /* .fade-leave-active below version 2.1.8 */ {
  opacity: 0;
}
</style>

<script>
import addEnum from "../base/addEnum";
import Multiselect from "vue-multiselect";

export default {
  components: {
    Multiselect,
    addEnum,
  },
  props: {
    value: {
      type: Array,
    },
    multiple: {
      type: Boolean,
      default: false,
    },
    id: {
      type: String,
      default: "",
    },
    disabled: {
      type: Boolean,
      default: false,
    },
    taggable: {
      type: Boolean,
      default: false,
    },
    isValid: {
      type: Boolean,
      default: true,
    },
    label: {
      type: String,
      default: "",
    },
    options: {
      type: Array,
      default() {
        return [];
      },
    },
    loading: {
      type: Boolean,
      default: false,
    },
    showButton: {
      type: Boolean,
      default: false,
    },
    categoryName: {
      type: String,
    },
    allowEmpty: {
      type: Boolean,
      default: false,
    },
    placeholder: {
      type: String,
      default: "",
    },
    debounceTime: {
      type: Number,
      default: 800,
    },
  },
  data() {
    return {
      output: this.value,
      isAdd: true,
      style: "",
      default:
        "background-color:whiteSmoke;padding-right: 12px;padding-left: 12px;  display: block;",
      debounceGet: null,
    };
  },
  methods: {
    enumSaved() {
      this.isAdd = true;
      this.$emit("enumSaved");
    },
    buttonClicked() {
      this.$emit("buttonClick");
      if (this.isAdd) {
        this.$emit("addClick");
      } else {
        this.$emit("closeClick");
      }
      this.isAdd = !this.isAdd;
    },
    searchChange(item) {
      this.$emit("searchChange", item);
    },
    delaySearch(value) {
      if (this.debounceGet) {
        clearTimeout(this.debounceGet);
        this.debounceGet = null;
      }
      this.debounceGet = setTimeout(
        () => this.$emit("searchChange", value),
        this.debounceTime
      );
    },
    addTag(item) {
      const tag = {
        text: item,
        value: "",
      };

      this.options.push(tag);
      this.output.push(tag);
      this.$emit("input", this.output);
    },

    updateValue() {
      this.$emit("input", this.output);
    },
  },
  watch: {
    value() {
      this.output = this.value;
    },
  },
  created() {
    this.style = this.default;
  },
};
</script>
